module.exports = __webpack_public_path__ + "media/images/stanfordmag-aa63e6c97f7fa0c29939be5a4c2eee3b.jpg";